var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9893 5.19467C8.23467 5.19467 5.184 8.23467 5.184 11.9893C5.17334 15.7333 8.224 18.784 11.9787 18.784C15.7227 18.784 18.7733 15.7333 18.7733 11.9787C18.7733 8.22401 15.7227 5.17334 11.968 5.17334L11.9893 5.19467ZM6.19734 11.9893C6.19627 8.78934 8.77867 6.19734 11.9787 6.19734C15.168 6.19734 17.76 8.77867 17.76 11.9787C17.76 15.168 15.168 17.76 11.968 17.76C8.768 17.76 6.176 15.168 6.176 11.968L6.19734 11.9893ZM11.9787 14.1227C13.152 14.1227 14.112 13.1627 14.112 11.9893C14.112 10.8053 13.152 9.85601 11.9787 9.85601C10.7947 9.85601 9.84534 10.8053 9.84534 11.9893C9.84534 13.1627 10.7947 14.1227 11.9787 14.1227Z",
    fill: "#9DA6AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioIcon);
export default __webpack_public_path__ + "static/media/radio-icon.1664a42a1ec0f020f04a16a25b533438.svg";
export { ForwardRef as ReactComponent };